import React, {Component} from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { fetchShoppingCartItems, fetchUserToken, sendEmailRequest, removeShoppingCartItems } from "../../redux/actions";

class DecisionButtons extends Component {
    sendEmail = () => {
      removeShoppingCartItems(this.props.userToken);
      sendEmailRequest(this.props.userToken, this.props.shoppingCartItems, this.props.orderListContactDetail);
    }

    render() {
      return(
        <div className="DecisionButtons">
          <Row className="show-grid">
            <Col md={6} mdPush={6}>
              <Link to="/order/info">
                <button type="button" className="btn btn-primary">RETURN</button>
              </Link>
            </Col>
            <Col md={6} mdPull={6}>
              <Link to="/order/complete">
                <button type="submit" className="btn btn-success" onClick={this.sendEmail}>CONFIRM ORDER</button>
              </Link>
            </Col>
          </Row>
        </div>
      );
    }
}


function mapStateToProps(state){
    return({
        userToken: state.userToken,
        shoppingCartItems: state.shoppingCartItems
    });
}

export default connect(mapStateToProps, {fetchUserToken, fetchShoppingCartItems, removeShoppingCartItems})(DecisionButtons);



// WEBPACK FOOTER //
// ./src/components/orderPage3/decisionButtons.js